module.exports = __webpack_public_path__ + "static/media/John-Guzman.0b9545d7.jpg";